/** @format */

import { type MouseEventHandler } from 'react';
import { format } from 'date-fns';
import { API_URL, NO_IMAGE_BASE64 } from 'src/constants';
import { getEventLink } from 'src/utils/helper';

const getDateFormatted = (date: number | string | undefined) => {
  if (!date) return '';
  return typeof date === 'number' ? format(new Date(date * 1000), 'dd.MM.yyyy') : date;
};

const getImageUrl = (image?: string) => {
  if (!image) return NO_IMAGE_BASE64;
  if (image.startsWith('http://') || image.startsWith('https://')) return image;
  return `${API_URL}${image}`;
};

type EventItemData = {
  title?: string;
  date?: number | string;
  image?: string;
  teaser?: string;
  content?: string;
  location?: string;
  link?: string;
  nid?: string | number;
  id?: string | number;
  linkTarget?: string;
};

type EventItemProps = {
  item?: EventItemData;
  className?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  openInNewTab?: boolean;
};

export const EventItem = ({ item, className = '', onClick, openInNewTab = true }: EventItemProps) => {
  const { title, date, image, teaser, content, location, linkTarget } = item || {};
  const href = getEventLink(item);
  const target = linkTarget || (openInNewTab ? '_blank' : '_self');

  return (
    <a
      href={href}
      target={target}
      rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      className={`events-widget--list-item ${className}`.trim()}
      onClick={onClick}>
      <div className="events-widget--list-item-image">
        <img src={getImageUrl(image)} alt={title || 'event'} />
      </div>
      <div className="events-widget--list-item-right">
        <div className="events-widget--list-item-header">
          <div className="events-widget--list-item-title">{title}</div>
          <div className="events-widget--list-item-date">{getDateFormatted(date)}</div>
        </div>
        {location ? <div className="events-widget--list-item-location">{location}</div> : null}
        <div className="events-widget--list-item-text">{teaser || content}</div>
      </div>
    </a>
  );
};
